/**
 * ImzaSeviyesiRozeti.jsx - the signature level of the Elektrik taahhütname as a badge (backlog #506, backend #505): "Dekoratör imzalı"
 * once the decorator signed, "Dekoratör + elektrikçi imzalı" once the stand's electrician countersigned on the fairground, with the
 * electrician's name under it when the list / detail read carries one. Draws nothing without a level, so a page can mount it for
 * every commitment. The panel on Proje Durumu (TaahhutnameDurumuPaneli) draws its own badge from the same helpers.
 */
import React from "react";
import { Badge } from "reactstrap";
import { useTranslation } from "react-i18next";
import { seviyeAnahtari, seviyeRengi } from "./taahhutnameYardimci";

export default function ImzaSeviyesiRozeti({ level, elektrikciName, className = "" }) {
  const { t } = useTranslation("projeler");
  const key = seviyeAnahtari(level);
  if (!key) return null;
  return (
    <div className={className} data-testid="imza-seviyesi">
      <Badge color={seviyeRengi(level)} className="fw-normal">{t(key)}</Badge>
      {level === "DEKORATOR_ELEKTRIKCI" && elektrikciName && (
        <div className="text-muted small mt-1" data-testid="imza-seviyesi-elektrikci">
          {t("taahhutnameDurumu.elektrikci.adi", { ad: elektrikciName })}
        </div>
      )}
    </div>
  );
}
